import { defineStore } from 'pinia';
import { removeRouteListener } from '@/utils/route-listener';
import type { UserState } from './types';
import { getUser } from '@/api/bi/user';
import { clearToken, goSSO } from '@/utils/auth';
import axiosInstance from '@/api/interceptor';
import { metadataBaseUrl } from '@/api/metadata/base';
import queryString from 'query-string';
import type { UserResponse } from '@/api/bi/user/types';
// import * as Sentry from '@sentry/vue';

const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      account: '',
      fullName: '',
      workCode: '',
      role: 'admin'
    };
  },

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    }
  },

  actions: {
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      const res = await getUser();
      const { account, fullName, workCode } = res.data as UserResponse;
      // Sentry.setUser({
      //   id: account,
      //   username: account
      // });
      if (account) {
        axiosInstance.interceptors.request.use(
          config => {
            if (config.url?.startsWith(metadataBaseUrl)) {
              if (config.data && typeof config.data === 'object') {
                config.data.account = account;
              }
              if (config.data && typeof config.data === 'string') {
                config.data = queryString.stringify({
                  ...queryString.parse(config.data),
                  account
                });
              }
              if (config.params && typeof config.params === 'object') {
                config.params.account = account;
              }
            }

            return config;
          },
          error => {
            return Promise.reject(error);
          }
        );
        this.setInfo({ account, fullName, workCode });
      }
    },

    // Logi
    logoutCallBack() {
      this.resetInfo();
      clearToken();
      removeRouteListener();
    },
    // Logout
    async logout() {
      this.logoutCallBack();
      goSSO();
    }
  }
});

export default useUserStore;
